import { render, staticRenderFns } from "./LinkDialog.vue?vue&type=template&id=31689883&"
import script from "./LinkDialog.vue?vue&type=script&lang=ts&"
export * from "./LinkDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LinkDialog.vue?vue&type=style&index=0&id=31689883&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports